<template>
  <avs-card>
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />
        <slot
          name="actions"
          v-bind:dataset="dataset"
        />
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        :items="dataset"
        :search="search"
        item-text="text"
        :loading-text="$t('categories.nonconformity.action.loading')"
        :no-results-text="$tc('categories.nonconformity.action.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
        @dblclick:row="($event, { item }) => toEdit(item)"
      >
        <template v-slot:item.end_date="{ item }">
          {{ toDatetime(item.end_date) }}
        </template>
        <template v-slot:item.monitoring_end_date="{ item }">
          {{ toDatetime(item.monitoring_end_date) }}
        </template>
        <template v-slot:item.total_cost="{ item }">
          {{ formatNumber(item.total_cost) }}
        </template>
        <template v-slot:item.type_action="{ item }">
          {{ getTextName(item.type_action) }}
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item.status)" />
        </template>
        <template v-slot:item.monitoring_status="{ item }">
          <component :is="handleStatusComponent(item.monitoring_status)" />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              @click.stop="toEdit(item)"
              :spantext="$t('actions.edit', { entity: $t('commons.action').toLowerCase() })"
            />
            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="$t('actions.delete', { entity: $t('commons.action').toLowerCase() })"
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Action"
      /> </template
  ></avs-card>
</template>

<script>
import { truncate } from "lodash"
// import _ from "lodash"
import { NonConformityService } from "@/services"
import { toDate, toDatetime } from "@/utils/datetime"
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { dateToString, now, FMTS } from "@/utils/datetime"

export default {
  name: "ActionsTable",
  components: { Closed, Ongoing, Overdue, Pending },
  props: {
    inspectionId: {
      type: Number,
      default: null
    }
  },
  computed: {
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      selectedItem: null,
      search: "",
      loading: false,
      dataset: [],
      headers: [
        {
          text: this.$t("commons.nc_number"),
          value: "non_conformity_number",
          class: "min-width-150"
        },
        {
          text: this.$tc("categories.nonconformity.action.name", 1),
          value: "name",
          class: "min-width-150"
        },
        { text: this.$t("commons.date.end_date"), value: "end_date" },
        { text: this.$t("commons.type"), align: "center", value: "type_action" },
        {
          text: this.$t("commons.cost") + " [€]",
          align: "center",
          value: "total_cost",
          class: "min-width-150"
        },
        { text: this.$t("commons.status.name"), align: "center", value: "status" },
        { text: this.$t("commons.intended_for"), align: "center", value: "user" },
        {
          text: this.$t("commons.monitoring_intended_for"),
          align: "center",
          value: "monitoring_user"
        },
        {
          text: this.$t("commons.date.end_date"),
          value: "monitoring_end_date"
        },
        {
          text: this.$t("commons.status.name"),
          value: "monitoring_status"
        },
        {
          text: this.$t("commons.actions"),
          sortable: false,
          value: "actions",
          align: "right",
          width: 120
        }
      ]
    }
  },
  methods: {
    truncate,
    toDate,
    toDatetime,
    getToEditLink(item) {
      return {
        name: "ActionCreateUpdate",
        params: { id: item.id }
      }
    },
    formatNumber(value) {
      if (!value) return ""
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    getActions() {
      let t = this
      this.loading = true
      NonConformityService.getListAllProjectActions(this.projectId)
        .then(r => {
          t.dataset = r
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          t.loading = false
        })
    },
    getTextName(item) {
      if (item == "Preventive") {
        return this.$t("commons.preventive")
      }
      if (item == "Corrective") {
        return this.$t("commons.corrective")
      }
      if (item == "Curative") {
        return this.$t("commons.curative")
      }
    },
    handleDelete(item) {
      NonConformityService.deleteAction(this, this.selectedItem.id).then(r => {
        this.dataset = this.dataset.filter(e => e.id !== this.selectedItem.id)
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", {
            entity: this.$tc("categories.nonconformity.name", 1)
          }),
          color: "success"
        })
      })
      this.deleteDialogIsOpen = false
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleStatusComponent(action) {
      return action
    },
    toEdit(item) {
      this.$router.push(this.getToEditLink(item))
    },
    isNCSigned(item) {
      return item.state === 4
    },
    async duplicateNonConformity(p) {
      NonConformityService.get(this, this.projectId, p.id)
        .then(async response => {
          // Override some keys
          let date = dateToString(now(), FMTS.FILE)
          response.nc_number = `${response.nc_number}-${date}`
          response.status = "Ongoing"
          response.lang = this.$i18n.locale

          // Téléchargez les images existantes et créez les nouvelles images
          let picturePromises = response.pictures.map(async picture => {
            let imageBlob = await fetch(picture.file_url).then(res => res.blob())

            // Convertir l'image Blob en base64
            let reader = await new Promise((resolve, reject) => {
              let fileReader = new FileReader()
              fileReader.onloadend = () => resolve(fileReader.result)
              fileReader.onerror = reject
              fileReader.readAsDataURL(imageBlob)
            })

            return {
              file: reader,
              label: "",
              hover: false,
              removed: false,
              timestamp: Date.now()
            }
          })

          // Attendez que toutes les promesses d'images soient résolues
          response.pictures = await Promise.all(picturePromises)

          // On Créé l'inspection
          NonConformityService.create(this, this.projectId, response.inspection.id, response)
            .then(res => {
              this.$store.commit("app/message", {
                msg: this.$t("messages.success.duplicated", {
                  entity: this.$tc("categories.nonconformity.name", 1)
                }),
                color: "success"
              })
              this.getActions()
            })
            .catch(error => {
              this.$emit("error", error)
            })
        })
        .catch(e => {
          if (e.status) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.not_allowed_duplicated"),
              color: "error"
            })
          }
        })
    }
  },
  mounted() {
    this.getActions()
  }
}
</script>

<style scoped>
.custom-toolbar >>> .v-toolbar__content {
  gap: 1rem;
}
</style>
